export default {
  data() {
    return {
      travelTop: [
        {
          path: "https://www.tabikobo.com/",
          name: "旅工房サービスサイト",
        },
      ],
      travelMenus: [
        {
          path: "https://www.tabikobo.com/tour/",
          name: "海外ツアー",
        },
        {
          path: "http://japanflight.tripstar.co.jp/jp/?source=tabikobo.com",
          name: "国内航空券",
        },
        {
          path: "https://www.rakudaclub.com/?afkey=tabikobo/",
          name: "国内ホテル",
        },
        {
          path: "https://www.tabikobo.com/corporate/#01",
          name: "海外出張",
        },
        {
          path: "https://www.tabikobo.com/corporate/#02",
          name: "団体旅行",
        },
        {
          path: "https://www.tabikobo.com/corporate/#03",
          name: "インバウンド",
        },
        {
          path: "https://www.tabikobo.com/corporate/#04",
          name: "学会・コンベンション",
        },
      ],
    };
  },
};
